/*
 * @Description: 渠道商管理
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2021-07-06 18:32:16
 * @LastEditTime: 2023-11-10 13:56:48
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */

import {
  get,
  post
} from '../index'
export default {
  // 审核列表
  channelList (querys) {
    return get('massage/admin/AdminChannel/channelList', querys)
  },
  // 下拉列表
  channelSelect (querys) {
    return get('massage/admin/AdminChannel/channelSelect', querys)
  },
  // 渠道-商详情
  channelInfo (querys) {
    return get('massage/admin/AdminChannel/channelInfo', querys)
  },
  // 新增渠道-商
  applyChannel (querys) {
    return post('massage/admin/AdminChannel/applyChannel', querys)
  },
  // 审核渠道-商
  channelUpdate (querys) {
    return post('massage/admin/AdminChannel/channelUpdate', querys)
  },
  // 关联用户
  nochannelUserList (querys) {
    return get('massage/admin/AdminChannel/nochannelUserList', querys)
  },
  // 设置提成比例
  setChannelBalance (querys) {
    return post('massage/admin/AdminChannel/setChannelBalance', querys)
  },
  // 删除提成比例
  delChannelBalance (querys) {
    return post('massage/admin/AdminChannel/delChannelBalance', querys)
  },
  // 绑定渠道商
  bindSalesman (querys) {
    return post('massage/admin/AdminChannel/bindSalesman', querys)
  },
  // 类目列表
  cateList (querys) {
    return get('massage/admin/AdminChannel/cateList', querys)
  },
  // 类目下拉
  cateSelect (querys) {
    return get('massage/admin/AdminChannel/cateSelect', querys)
  },
  // 类目详情
  cateInfo (querys) {
    return get('massage/admin/AdminChannel/cateInfo', querys)
  },
  // 新增类目
  cateAdd (querys) {
    return post('massage/admin/AdminChannel/cateAdd', querys)
  },
  // 编辑类目
  cateUpdate (querys) {
    return post('massage/admin/AdminChannel/cateUpdate', querys)
  },
  // 渠道码绑定人员
  channelUserList (querys) {
    return get('massage/admin/AdminChannel/channelUserList', querys)
  },
  // 渠道码列表
  channelQr (querys) {
    return get('massage/admin/AdminChannel/channelQr', querys)
  },
  // 渠道码详情
  channelQrInfo (querys) {
    return get('massage/admin/AdminChannel/channelQrInfo', querys)
  },
  // 新增渠道码
  channelQrAdd (querys) {
    return post('massage/admin/AdminChannel/channelQrAdd', querys)
  },
  // 编辑渠道码
  channelQrUpdate (querys) {
    return post('massage/admin/AdminChannel/channelQrUpdate', querys)
  },
  // 删除渠道码
  channelQrDel (querys) {
    return post('massage/admin/AdminChannel/channelQrDel', querys)
  },
  // 批量绑定人员
  bindChannel (querys) {
    return post('massage/admin/AdminChannel/bindChannel', querys)
  },
  // 下载二维码
  downloadQr (querys) {
    return post('massage/admin/AdminChannel/downloadQr', querys)
  },
  // 渠道码统计
  channelQrList (querys) {
    return get('massage/admin/AdminChannel/channelQrList', querys)
  },
  // 设置渠道码比例
  setChannelQrBalance (querys) {
    return post('massage/admin/AdminChannel/setChannelQrBalance', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/channel.js